module.exports = __webpack_public_path__ + "static/media/x.5b8e2186.svg";